// Display utility helpers for dates.
// Backend persists/expects ISO YYYY-MM-DD. UI displays MM-DD-YYYY.

/**
 * Format an ISO YYYY-MM-DD string as MM-DD-YYYY.
 * Returns an em-dash for empty / invalid inputs.
 */
export function formatDateUS(iso) {
  if (!iso || typeof iso !== 'string') return '—';
  const m = iso.match(/^(\d{4})-(\d{2})-(\d{2})/);
  if (!m) return iso;
  return `${m[2]}-${m[3]}-${m[1]}`;
}

/** Same as formatDateUS, but returns an empty string for blanks (useful in inputs). */
export function formatDateUSorEmpty(iso) {
  const v = formatDateUS(iso);
  return v === '—' ? '' : v;
}
